module.exports = __webpack_public_path__ + "static/AutoMox-1802495838f36307b0466d3fc6f0a0ec.png";